import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {ERROR} from '@di-shared/const';
import Header from '@di-shared/features/common/Header';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import clsx from 'clsx';
import useUnitConverter from '@di-shared/utils/useUnitConverter';

function UbiDetailContentsLoading() {
  const {t} = useInferableTranslation();
  const {defaultDistanceSymbol} = useUnitConverter();
  return (
    <div className="wrap">
      <ScrollToTopOnMount />
      <Header left={<HeaderBackButton />}>
        <h1 className="title_xsmall_b nav_center_title">{ERROR.DASH}</h1>
      </Header>

      <main className="content page_ubi">
        <section className="section">
          <ul className="contract_list">
            <li className="contract_item skeleton">
              <div className="contract_heading">
                <div className="contract_title">
                  <h2 className="contract_name">{'커넥티드카 안전운전 할인특약(개인용)'}&nbsp;</h2>
                  <span className="contract_rate">
                    {t('T20042_$discount', {
                      discount: `14.2`,
                    })}
                  </span>
                </div>
              </div>
              <p className="contract_desc">{'최근 90일간 최소 500km 이상 주행 및안전운전 점수 70점 이상 시'}</p>
            </li>
            <li className="contract_item skeleton">
              <div className="contract_heading">
                <div className="contract_title">
                  <h2 className="contract_name">{'커넥티드카 안전운전 할인특약(개인용)'}&nbsp;</h2>
                  <span className="contract_rate">
                    {t('T20042_$discount', {
                      discount: `14.2`,
                    })}
                  </span>
                </div>
              </div>
              <p className="contract_desc">{'최근 90일간 최소 500km 이상 주행 및안전운전 점수 70점 이상 시'}</p>
              <div className="section_container">
                <div className="ubi_my">
                  <ul className="ubi_my_list">
                    <li className={clsx('ubi_my_item')}>
                      <span className="ubi_my_key">{t('T20022')}</span>
                      <span className="ubi_my_val">
                        2000
                        {defaultDistanceSymbol}
                      </span>
                      <span className="ubi_my_detail">{t('T20043')}</span>
                    </li>
                    <li className={clsx('ubi_my_item')}>
                      <span className="ubi_my_key">{t('T20045')}</span>
                      <span className="ubi_my_val">{t('T20006_$score', {score: 100})}</span>
                      <span className="ubi_my_detail">{t('T20043')}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <li className="contract_item skeleton">
              <div className="contract_heading">
                <div className="contract_title">
                  <h2 className="contract_name">{'커넥티드카 안전운전 할인특약(개인용)'}&nbsp;</h2>
                  <span className="contract_rate">
                    {t('T20042_$discount', {
                      discount: `14.2`,
                    })}
                  </span>
                </div>
              </div>
              <p className="contract_desc">{'최근 90일간 최소 500km 이상 주행 및안전운전 점수 70점 이상 시'}</p>
            </li>
          </ul>
        </section>
      </main>
    </div>
  );
}

export default UbiDetailContentsLoading;
